var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "change-generation-mode-component",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__(
        "listing.batchComponents.ChangeGenerationModeComponent.change_generation_mode"
      )
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("div", { staticClass: "dialog__header" }, [
              _c("div", { staticClass: "dialog__header--title" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog__header--close" },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "close" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__default" },
              [
                _c(
                  "p",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Deux modes sont disponibles :")) +
                        "\n                "
                    ),
                    _c(
                      "ul",
                      {
                        staticClass: "ml-2",
                        staticStyle: { "list-style-type": "disc" }
                      },
                      [
                        _c("li", [
                          _vm._v(
                            _vm._s(
                              _vm.$l10n.__(
                                'Mode "Automatique" : Envoie automatiquement un email avec la facture à votre destinataire.'
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            _vm._s(
                              _vm.$l10n.__(
                                'Mode "Après validation" : Vous recevez une notification de création de facture et vous pourrez ensuite transmettre manuellement la facture à votre client.'
                              )
                            )
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.modes, function(modeItem) {
                  return _c(
                    "div",
                    { key: modeItem.value, staticClass: "mb-2" },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: modeItem.value },
                          model: {
                            value: _vm.mode,
                            callback: function($$v) {
                              _vm.mode = $$v
                            },
                            expression: "mode"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(modeItem.label) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                })
              ],
              2
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.$t.__("common.actions.confirm"),
                    type: "primary"
                  },
                  on: { click: _vm.save }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }